// Types
import { APIAction } from 'types'

// Utils
import { recommendationsSong, recommendationsArtist, recommendationsCollection } from 'normalize'

const BASE_URL = '/api/recommendations'

export const actions = {
  fetchSongRecommendations: (songSlug: string): APIAction => ({
    CALL_API: {
      type: 'FETCH_SONG_RECOMMENDATIONS',
      method: 'GET',
      endpoint: `${BASE_URL}/song/${songSlug}/`,
      schema: recommendationsSong,
      requestKey: songSlug,
      actionParams: { songSlug },
      merge: true,
    },
  }),

  fetchQueryRecommendations: (queryString: string): APIAction => ({
    CALL_API: {
      type: 'FETCH_SEARCH_QUERY_RECOMMENDATIONS',
      method: 'GET',
      endpoint: `${BASE_URL}/query/${queryString.startsWith('?') ? '' : '?'}${queryString}`,
      schema: recommendationsSong,
      requestKey: queryString,
      merge: true,
    },
  }),

  fetchArtistRecommendations: (artistSlug: string): APIAction => ({
    CALL_API: {
      type: 'FETCH_ARTIST_RECOMMENDATIONS',
      method: 'GET',
      endpoint: `${BASE_URL}/artist/${artistSlug}/`,
      schema: recommendationsArtist,
      actionParams: {
        artistSlug,
      },
      requestKey: artistSlug,
      merge: true,
    },
  }),

  fetchCollectionRecommendations: (collectionId: number | string): APIAction => ({
    CALL_API: {
      type: 'FETCH_COLLECTION_RECOMMENDATIONS',
      method: 'GET',
      endpoint: `${BASE_URL}/collection/${collectionId}/`,
      schema: recommendationsCollection,
      actionParams: { collectionId },
      requestKey: collectionId,
      merge: true,
    },
  }),
}
